import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=a4f901e4&scoped=true"
import script from "./Assistance.vue?vue&type=script&lang=js"
export * from "./Assistance.vue?vue&type=script&lang=js"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=a4f901e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f901e4",
  null
  
)

export default component.exports